module.exports = __webpack_public_path__ + "static/media/banner-img-desktop.7cfc58fc.png";